// api/Customer/NotificationRequests.js
import axios from "axios";
import Config from "../../utils/Config";

const GENERAL_API_URL = `${Config.baseUrl}api`;

class NotificationRequests {
  getHeaders() {
    const token = localStorage.getItem("txtconnect_ng_user_token");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  async getNotificationSettings() {
    try {
        console.log("Fetching notification settings with headers:", this.getHeaders());
      const response = await axios.get(
        `${GENERAL_API_URL}/user/external_notifications`,
        {
          headers: this.getHeaders(),
        }
      );

      if (response.data?.data?.status_code === "000") {
        return {
          success: true,
          data: response.data.data.data || [],
          message: response.data.data.reason || "Notification settings fetched successfully",
        };
      }

      return {
        success: false,
        data: [],
        message: response.data?.data?.reason || "Failed to fetch notification settings",
      };
    } catch (error) {
      console.error("Error fetching notification settings:", error);
      return {
        success: false,
        data: [],
        message:
          error?.response?.data?.data?.reason ||
          error?.response?.data?.message ||
          "Error fetching notification settings",
      };
    }
  }

  async updateNotificationSettings(settingsData) {
    try {
      const response = await axios.put(
        `${GENERAL_API_URL}/user/external_notifications/update`,
        settingsData,
        {
          headers: this.getHeaders(),
        }
      );

      if (response.data?.data?.status_code === "000") {
        return {
          success: true,
          data: response.data.data,
          message: response.data.data.reason || "Notification settings updated successfully",
        };
      }

      return {
        success: false,
        data: null,
        message: response.data?.data?.reason || "Failed to update notification settings",
      };
    } catch (error) {
      console.error("Error updating notification settings:", error);
      return {
        success: false,
        data: null,
        message:
          error?.response?.data?.data?.reason ||
          error?.response?.data?.message ||
          "Error updating notification settings",
      };
    }
  }
}

const notificationRequests = new NotificationRequests();
export default notificationRequests;